import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col" }
const _hoisted_2 = { class: "w-full bg-pattern bg-cover flex flex-col p-5 lg:px-[30rem] space-y-5 pb-44 lg:pb-32" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-center font-bold lg:font-medium text-2xl lg:text-3xl" }, " IP Address Tracker ", -1)
const _hoisted_4 = { class: "w-full px-5 lg:px-40" }
const _hoisted_5 = { class: "relative flex justify-center items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full relative" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "map",
    class: "w-full h-full absolute z-0 cursor-move"
  })
], -1)

import { Map } from 'leaflet';
import { ref, onMounted } from 'vue';
import 'leaflet/dist/leaflet.css';

import TheSearchBar from '@/components/TheSearchBar.vue';
import TheResponseBox from '@/components/TheResponseBox.vue';

import { ApiResponse } from '@/types/types';

import { useGeoApi } from '@/utils/useGeoApi';
import TheCard from './components/TheCard.vue';
import TheSpinner from './components/TheSpinner.vue';
import TheAdBlockerWarning from './components/TheAdBlockerWarning.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const map = ref<Map>();
const ipAddress = ref<string>();
const responseData = ref<ApiResponse>();
const isLoading = ref<boolean>();
const isError = ref<boolean>(false);

onMounted(handleGeoApi);

const handleIpInputSubmit = async () => {
  await handleGeoApi(map.value);
};

async function handleGeoApi(leafletMapInstance?: Map) {
  isLoading.value = true;

  try {
    const { leafletMap, response } = await useGeoApi(
      ipAddress.value,
      leafletMapInstance
    );

    ipAddress.value = response.ip;
    responseData.value = response;
    map.value = leafletMap;
  } catch (e) {
    isError.value = true;
  } finally {
    isLoading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createVNode(TheSearchBar, {
        modelValue: ipAddress.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ipAddress).value = $event)),
        onSubmit: handleIpInputSubmit
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TheCard, { class: "absolute w-full shadow-2xl" }, {
          default: _withCtx(() => [
            (isLoading.value)
              ? (_openBlock(), _createBlock(TheSpinner, { key: 0 }))
              : (isError.value)
                ? (_openBlock(), _createBlock(TheAdBlockerWarning, { key: 1 }))
                : (_openBlock(), _createBlock(TheResponseBox, {
                    key: 2,
                    "response-data": responseData.value
                  }, null, 8, ["response-data"]))
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_6
  ]))
}
}

})